import country from "./Resources/country.json"

export const OnlineMerchantCountryOrRegionOptions = country.country.map(({ code, name }) => ({
  key: code,
  title: name,
  value: code,
}))